import { Skeleton } from "antd";
import styled from "styled-components";

export const StyledMainLabel = styled.label`
  padding-bottom: 8px;
`;
StyledMainLabel.displayName = "StyledMainLabel";

export const StyledFixtureScoreSkeleton = styled(Skeleton.Input)`
  && {
    display: block;

    width: 204px;
    .ant-skeleton-input { width: 204px; }
  }
`;
StyledFixtureScoreSkeleton.displayName = "StyledFixtureScoreSkeleton";

export const StyledInputsContainer = styled.div`
  background-color: #ffffff80;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  height: 32px;

  display: flex;
  align-items: center;
  gap: 3px;

  & > div input {
    height: 24px;
    aspect-ratio: 12 / 5;
  }

  & > div label {
    padding: 0 13px;
    &::after {
      display: none;
    }
  }

  & > div + div {
    .ant-row {
      flex-direction: row-reverse;
    }
  }
`;
StyledInputsContainer.displayName = "StyledInputsContainer";
